<template>
  <header class="header">
    <div class="header-inner">
      <div class="logo">
        <router-link to="/">
          <img src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=modern%20company%20logo%20blue%20abstract&image_size=square" alt="新恒丰集团">
          <span class="logo-text">新恒丰集团</span>
        </router-link>
      </div>
      
      <nav class="nav-menu" :class="{ 'nav-menu-open': isMenuOpen }">
        <ul class="nav-list">
          <li
            v-for="item in navItems"
            :key="item.path"
            class="nav-item"
            :class="{ 'has-children': item.children && item.children.length }"
            @mouseenter="onNavEnter(item)"
            @mouseleave="onNavLeave(item)"
          >
            <router-link 
              :to="item.path" 
              class="nav-link"
              :class="{ active: $route.path === item.path }"
              @click="onNavClick(item)"
            >
              {{ item.name }}
              <i v-if="item.children && item.children.length" class="el-icon-arrow-down nav-arrow"></i>
            </router-link>
          </li>
        </ul>
      </nav>

      <div class="header-right">
        <div class="header-phone">
          <i class="el-icon-phone"></i>
          <span>0371-56972228</span>
        </div>
        <button class="search-btn" @click="toggleSearch">
          <i class="el-icon-search"></i>
        </button>
        <button class="mobile-menu-btn" @click="toggleMenu">
          <i class="el-icon-menu"></i>
        </button>
      </div>

      <div class="search-box" :class="{ 'search-box-show': showSearch }">
        <input type="text" placeholder="搜索..." class="search-input">
        <button class="search-submit" @click="toggleSearch">
          <i class="el-icon-search"></i>
        </button>
        <button class="search-close" @click="toggleSearch">
          <i class="el-icon-close"></i>
        </button>
      </div>
    </div>

    <!-- Mega Menu 全宽横向子菜单 -->
    <transition name="megamenu">
      <div
        v-if="activeDropdown && currentChildren.length"
        class="megamenu-bar"
        @mouseenter="clearHideTimer"
        @mouseleave="startHideTimer"
      >
        <div class="megamenu-inner">
          <div class="megamenu-title">
            <span class="megamenu-title-line"></span>
            <span class="megamenu-title-text">{{ currentParentName }}</span>
          </div>
          <div class="megamenu-items">
            <router-link
              v-for="child in currentChildren"
              :key="child.path"
              :to="child.path"
              class="megamenu-item"
              :class="{ active: isChildActive(child) }"
              @click="isMenuOpen = false"
            >
              <span class="megamenu-item-text">{{ child.name }}</span>
              <i class="el-icon-arrow-right megamenu-item-arrow"></i>
            </router-link>
          </div>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      isMenuOpen: false,
      showSearch: false,
      activeDropdown: null,
      hideTimer: null,
      navItems: [
        { name: '首页', path: '/' },
        {
          name: '关于我们',
          path: '/about',
          children: [
            { name: '集团概览', path: '/about#overview' },
            { name: '发展历程', path: '/about#history' },
            { name: '荣誉资质', path: '/about#honor' },
            { name: '组织架构', path: '/about#structure' },
            { name: '企业文化', path: '/about#culture' },
            { name: '领导风采', path: '/about#leader' },
            { name: '企业视频', path: '/about#video' }
          ]
        },
        { name: '服务项目', path: '/services' },
        {
          name: '新闻中心',
          path: '/news',
          children: [
            { name: '新闻中心', path: '/news?cat=all' },
            { name: '企业动态', path: '/news?cat=company' },
            { name: '行业资讯', path: '/news?cat=industry' },
            { name: '政策法规', path: '/news?cat=policy' }
          ]
        },
        {
          name: '典型案例',
          path: '/cases',
          children: [
            { name: '典型案例', path: '/cases?cat=all' },
            { name: '国家级奖项项目', path: '/cases?cat=national' },
            { name: '房屋建筑', path: '/cases?cat=building' },
            { name: '市政公用工程', path: '/cases?cat=municipal' },
            { name: '公益工程', path: '/cases?cat=public' },
            { name: '电力工程', path: '/cases?cat=power' },
            { name: '冶煤工程', path: '/cases?cat=metallurgy' },
            { name: '航空航天工程', path: '/cases?cat=aerospace' },
            { name: '项目管理', path: '/cases?cat=pm' },
            { name: '第三方评估', path: '/cases?cat=thirdparty' }
          ]
        },
        { name: '社会责任', path: '/responsibility' },
        { name: '党建工作', path: '/party-building' },
        { name: '联系我们', path: '/contact' }
      ]
    }
  },
  computed: {
    currentParent() {
      return this.navItems.find(n => n.path === this.activeDropdown)
    },
    currentChildren() {
      return this.currentParent ? (this.currentParent.children || []) : []
    },
    currentParentName() {
      return this.currentParent ? this.currentParent.name : ''
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    toggleSearch() {
      this.showSearch = !this.showSearch
    },
    onNavEnter(item) {
      if (window.innerWidth <= 768) return
      if (item.children && item.children.length) {
        this.clearHideTimer()
        this.activeDropdown = item.path
      }
    },
    onNavLeave(item) {
      if (window.innerWidth <= 768) return
      if (item.children && item.children.length) {
        this.startHideTimer()
      }
    },
    clearHideTimer() {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer)
        this.hideTimer = null
      }
    },
    startHideTimer() {
      this.clearHideTimer()
      this.hideTimer = setTimeout(() => {
        this.activeDropdown = null
      }, 150)
    },
    onNavClick(item) {
      this.isMenuOpen = false
      if (window.innerWidth <= 768 && item.children && item.children.length) {
        event.preventDefault()
        this.activeDropdown = this.activeDropdown === item.path ? null : item.path
      }
    },
    isChildActive(child) {
      // 支持三种匹配：hash 锚点、query 分类、纯路径
      const childPath = child.path
      const hashMatch = this.$route.path + '#' + (this.$route.hash || '')
      if ('/' + hashMatch === childPath || hashMatch === childPath) return true
      // query 匹配
      const queryMatch = this.$route.path
      const childBase = childPath.split('?')[0].split('#')[0]
      if (queryMatch === childBase) {
        // 路径相同，继续检查 query
        const childQueryStr = childPath.includes('?') ? childPath.split('?')[1] : ''
        if (childQueryStr) {
          const params = new URLSearchParams(childQueryStr)
          for (const [key, val] of params) {
            if (this.$route.query[key] !== val) return false
          }
          return true
        }
        return !this.$route.query.cat
      }
      return false
    }
  },
  watch: {
    '$route'() {
      this.activeDropdown = null
      this.isMenuOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.header-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}

.logo {
  display: flex;
  align-items: center;

  img {
    width: 50px;
    height: 50px;
    border-radius: 8px;
    animation: fadeInScale 0.5s ease;
  }

  .logo-text {
    margin-left: 12px;
    font-size: 20px;
    font-weight: bold;
    color: #1a56db;
  }

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.nav-menu {
  display: flex;
  align-items: center;

  &-open {
    display: flex;
  }
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  position: relative;
}

.nav-link {
  position: relative;
  padding: 8px 14px;
  font-size: 15px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s ease;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;

  .nav-arrow {
    margin-left: 3px;
    font-size: 12px;
    transition: transform 0.3s ease;
  }

  &:hover {
    color: #1a56db;
    background: rgba(26, 86, 219, 0.1);
    transform: translateY(-2px);

    .nav-arrow {
      transform: rotate(180deg);
    }
  }

  &.active {
    color: #1a56db;
    font-weight: bold;

    &::after {
      content: '';
      position: absolute;
      bottom: 5px;
      left: 50%;
      transform: translateX(-50%);
      width: 30px;
      height: 3px;
      background: linear-gradient(90deg, #1a56db, #4f46e5);
      border-radius: 2px;
      animation: lineGrow 0.3s ease;
    }
  }
}

@keyframes lineGrow {
  from {
    width: 0;
  }
  to {
    width: 30px;
  }
}

/* ===== Mega Menu 全宽横向面板 ===== */
.megamenu-bar {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  background: #fff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  border-top: 1px solid rgba(26, 86, 219, 0.08);
  z-index: 150;
}

.megamenu-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 28px 20px;
}

.megamenu-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .megamenu-title-line {
    display: inline-block;
    width: 4px;
    height: 20px;
    background: linear-gradient(180deg, #1a56db, #3b82f6);
    border-radius: 2px;
    margin-right: 12px;
  }

  .megamenu-title-text {
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
  }
}

.megamenu-items {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.megamenu-item {
  display: inline-flex;
  align-items: center;
  padding: 14px 28px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 15px;
  color: #475569;
  text-decoration: none;
  transition: all 0.25s ease;
  white-space: nowrap;
  position: relative;

  .megamenu-item-text {
    position: relative;
    z-index: 1;
  }

  .megamenu-item-arrow {
    margin-left: 8px;
    font-size: 14px;
    opacity: 0;
    transform: translateX(-4px);
    transition: all 0.25s ease;
    position: relative;
    z-index: 1;
  }

  &:hover {
    color: #fff;
    background: linear-gradient(135deg, #1a56db, #3b82f6);
    border-color: transparent;
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(26, 86, 219, 0.3);

    .megamenu-item-arrow {
      opacity: 1;
      transform: translateX(0);
    }
  }

  &.active {
    color: #fff;
    background: linear-gradient(135deg, #1a56db, #3b82f6);
    border-color: transparent;
    font-weight: 600;

    .megamenu-item-arrow {
      opacity: 1;
      transform: translateX(0);
    }
  }
}

/* ===== Mega Menu 动画 ===== */
.megamenu-enter-active,
.megamenu-leave-active {
  transition: all 0.3s ease;
}

.megamenu-enter,
.megamenu-leave-to {
  opacity: 0;
  transform: translateY(-8px);
  pointer-events: none;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.header-phone {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: 6px;

  i {
    color: #1a56db;
    font-size: 16px;
  }

  span {
    font-size: 15px;
    font-weight: 600;
    color: #1a56db;
    letter-spacing: 0.3px;
    white-space: nowrap;
  }
}

.search-btn,
.mobile-menu-btn {
  width: 40px;
  height: 40px;
  border: none;
  background: rgba(26, 86, 219, 0.1);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  i {
    font-size: 18px;
    color: #1a56db;
  }

  &:hover {
    background: rgba(26, 86, 219, 0.2);
    transform: scale(1.05);
  }
}

.mobile-menu-btn {
  display: none;
}

.search-box {
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translateX(-50%) scale(0.9);
  width: 80%;
  max-width: 500px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  padding: 10px 20px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;

  &-show {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) scale(1);
  }
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 8px;
}

.search-submit {
  margin-left: 15px;
  width: 45px;
  height: 45px;
  border: none;
  background: linear-gradient(135deg, #1a56db, #4f46e5);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  i {
    color: white;
    font-size: 18px;
  }

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 15px rgba(26, 86, 219, 0.4);
  }
}

.search-close {
  margin-left: 10px;
  border: none;
  background: none;
  cursor: pointer;

  i {
    font-size: 20px;
    color: #999;
  }
}

/* ===== 中等屏幕适配 (解决8个菜单项挤压问题) ===== */
@media (max-width: 1180px) {
  .nav-link {
    padding: 8px 10px;
    font-size: 14px;
  }

  .header-phone span {
    font-size: 14px;
  }

  .search-btn,
  .mobile-menu-btn {
    width: 36px;
    height: 36px;

    i {
      font-size: 16px;
    }
  }

  .logo-text {
    font-size: 18px;
  }

  .header-right {
    gap: 10px;
  }
}

/* ===== 窄屏在移动端之前 - 显示汉堡菜单代替桌面导航 ===== */
@media (max-width: 992px) and (min-width: 769px) {
  .nav-menu {
    position: fixed;
    top: 80px;
    left: 0;
    right: 0;
    background: white;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    flex-direction: column;
    padding: 16px;
    display: none;
    animation: slideDownMenu 0.3s ease;
    max-height: calc(100vh - 80px);
    overflow-y: auto;
    z-index: 200;

    &.nav-menu-open {
      display: flex;
    }
  }

  .nav-list {
    flex-direction: column;
    width: 100%;
  }

  .nav-item {
    width: 100%;
  }

  .nav-link {
    display: flex;
    justify-content: space-between;
    text-align: left;
    padding: 14px 16px;
    font-size: 15px;
    border-radius: 8px;

    &:hover {
      transform: none;
    }
  }

  .megamenu-bar {
    position: static;
    box-shadow: none;
    border-top: none;
    border-bottom: none;
    background: #f8fafc;
  }

  .megamenu-inner {
    padding: 16px 16px 16px 20px;
    border-left: 3px solid #1a56db;
    margin-left: 16px;
  }

  .megamenu-items {
    flex-direction: column;
    gap: 8px;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .header-phone span {
    display: none;
  }
}

/* ===== 移动端响应式 ===== */
@media (max-width: 768px) {
  .header-inner {
    height: 64px;
    padding: 0 16px;
  }

  .logo {
    img {
      width: 40px;
      height: 40px;
    }

    .logo-text {
      margin-left: 10px;
      font-size: 20px;
    }
  }

  .nav-menu {
    position: fixed;
    top: 64px;
    left: 0;
    right: 0;
    background: white;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    flex-direction: column;
    padding: 16px;
    display: none;
    animation: slideDownMenu 0.3s ease;
    max-height: calc(100vh - 64px);
    overflow-y: auto;
    z-index: 200;
  }

  @keyframes slideDownMenu {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .nav-list {
    flex-direction: column;
    width: 100%;
  }

  .nav-item {
    width: 100%;
  }

  .nav-link {
    display: flex;
    justify-content: space-between;
    text-align: left;
    padding: 14px 16px;
    font-size: 16px;
    border-radius: 8px;

    &:hover {
      transform: none;
    }
  }

  /* 移动端 mega menu 改为嵌套展开 */
  .megamenu-bar {
    position: static;
    box-shadow: none;
    border-top: none;
    border-bottom: none;
    background: #f8fafc;
  }

  .megamenu-inner {
    padding: 16px 16px 16px 20px;
    border-left: 3px solid #1a56db;
    margin-left: 16px;
  }

  .megamenu-title {
    margin-bottom: 12px;

    .megamenu-title-line {
      display: none;
    }

    .megamenu-title-text {
      font-size: 15px;
      color: #64748b;
    }
  }

  .megamenu-items {
    flex-direction: column;
    gap: 8px;
  }

  .megamenu-item {
    padding: 12px 16px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 15px;

    &:hover {
      transform: none;
    }
  }

  .mobile-menu-btn {
    display: flex;
  }

  .search-box {
    top: 74px;
    width: 95%;
    padding: 8px 14px;
  }

  .search-input {
    font-size: 15px;
    padding: 10px;
  }

  .search-submit {
    margin-left: 10px;
    width: 40px;
    height: 40px;

    i {
      font-size: 16px;
    }
  }

  .search-btn,
  .mobile-menu-btn {
    width: 36px;
    height: 36px;

    i {
      font-size: 16px;
    }
  }

  .header-right {
    gap: 10px;
  }

  .header-phone {
    span {
      display: none;
    }
    i {
      font-size: 16px;
    }
    margin-right: 0;
    gap: 0;
  }
}

@media (max-width: 480px) {
  .logo {
    img {
      width: 36px;
      height: 36px;
    }

    .logo-text {
      margin-left: 8px;
      font-size: 18px;
    }
  }

  .nav-link {
    padding: 12px 8px;
    font-size: 15px;
  }
}
</style>
